import { m } from 'framer-motion';
import React, { useState } from "react";
import './homepage.css'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Container,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Image from "../image";
import { useResponsive } from "../../hooks/use-responsive";
import { MotionViewport, varFade, } from '../animate';

export default function FeatureSection() {
    const mdUp = useResponsive("up", "md");

    const containerData = [
        {
            iconImage: "/assets/keep_friendly.svg",
            mainImg: "/assets/Safe_for_Kids.svg",
            title: "Safe for",
            titleHl: "kids",
            description:
                "MegaConnect ensures your child's safety by blocking malicious websites, inappropriate content, and risky domains. With real-time threat protection, your child’s online experience remains secure and controlled.",
        },
        {
            iconImage: "/assets/SimplePricing.svg",
            mainImg: "/assets/Affordable_Solution.svg",
            title: "Affordable",
            titleHl: "Solution",
            description:
                "Starting at just ₹399/month, MegaConnect lets you use your existing Windows device with our app for easy access to your cloud PC—providing a cost-effective way for your child to learn and grow!",
        },
        {
            iconImage: "/assets/work_from_anywhere1.svg",
            mainImg: "/assets/AccessFromAnywhere.svg",
            title: "Access from",
            titleHl: "Anywhere",
            description:
                "With MegaConnect, your child can learn from anywhere be it at home, school, or a friend’s computer. They can easily switch between different devices, one at a time.",
        },
      
        {
            iconImage: "/assets/made_for_learning.svg",
            mainImg: "/assets/Designed_for_Learning_Playing.svg",
            title: "Made for",
            titleHl: "Learning & Playing",
            description:
                "MegaConnect offers a Windows cloud pc for your child to learn and play. You can choose from a list of applications to install in their cloud PC, creating a fun and educational experience!",
        },
        {
            iconImage: "/assets/EasyUpgrades.svg",
            mainImg: "/assets/High_Speed_Internet.svg",
            title: "High-Speed",
            titleHl: "Internet",
            description:
                "MegaConnect provides high-speed internet with up to 1 Gbps, saving your child valuable time when accessing the cloud pc.",
        },
        {
            iconImage: "/assets/Data_Backup.svg",
            mainImg: "/assets/Data_Backup_main.svg",
            title: "Data",
            titleHl: "Backup",
            description:
                "MegaConnect provides automatic data backup every 24 hours, ensuring your child's work is always safe. You can have peace of mind knowing that their important files are protected!",
        },
    ];

    // State to keep track of the currently selected accordion
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [expandedIndex, setExpandedIndex] = useState(0); // Track the expanded accordion index

    const handleAccordionChange = (index) => {
        if (expandedIndex === index) {
            // If the same accordion is clicked, collapse it
            setExpandedIndex(null);
        } else {
            // Expand the new accordion and update the selected image
            setExpandedIndex(index);
            setSelectedIndex(index);
        }
    };

    return (
        <Container maxWidth={false} sx={{ mb: 5 }} component={MotionViewport} >
            <Grid container spacing={4}>
            <Grid item xs={12} md={12}>
            <m.div variants={varFade({ distance: 120, durationIn: 0.9 }).inLeft} >
                    {mdUp && (
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            textAlign="justify"
                            component="p"
                            sx={{
                                fontSize: 16,
                                fontFamily: "Roboto Flex",
                                fontStyle: "italic",
                                fontWeight: "600",
                                textTransform: "uppercase",
                            }}
                        >
                            GROW WITH<span style={{ color: "#1E53E8" }}> MEGACONNECT.</span>
                        </Typography>
                    )}
                    {!mdUp && (
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            textAlign="center"
                            component="p"
                            sx={{
                                fontSize: 16,
                                fontFamily: "Roboto Flex",
                                fontStyle: "italic",
                                fontWeight: "600",
                                textTransform: "uppercase",
                            }}
                        >
                            GROW WITH<span style={{ color: "#1E53E8" }}> MEGACONNECT.</span>
                        </Typography>
                    )}
                    {mdUp && (
                        <Typography
                            variant="h2"
                            className="heading3"
                            textAlign="left"
                            component="P"
                        >
                            WE PROVIDE YOU THE BEST FEATURES FOR
                            <span style={{ color: "#1E53E8" }}> CHILD'S GROWTH </span>
                        </Typography>
                    )}
                    {!mdUp && (
                        <Typography
                            variant="h4"
                            marginBottom={1}
                            className="heading3"
                            textAlign="center"
                            component="P"
                        >
                            WE PROVIDE YOU THE BEST FEATURES FOR
                            <span style={{ color: "#1E53E8" }}> CHILD'S GROWTH </span>
                        </Typography>
                    )}
                    {mdUp && (
                        <Typography
                            sx={{ fontSize: "18px", mb: 2 }}
                            className="heroTxt"
                            textAlign="left"
                            gutterBottom
                        >
                            Our features are designed to support your child's learning and
                            development in a safe and engaging environment.
                        </Typography>
                    )}
                    {!mdUp && (
                        <Typography
                            className="heroTxt"
                            sx={{ fontSize: "18px", fontWeight: 800, mb: 2 }}
                            textAlign="center"
                            gutterBottom
                        >
                            Our features are designed to support your child's learning and
                            development in a safe and engaging environment.
                        </Typography>
                    )}
                    </m.div>
                    </Grid>
                {/* First Grid: Accordion List */}
                <Grid item xs={12} md={6}>
               

                    {mdUp && <>
                        {containerData.map((item, index) => (
                            <Accordion
                                key={index}
                                expanded={expandedIndex === index}
                                onChange={() => handleAccordionChange(index)}
                                component={m.div}
                                variants={varFade({ distance: 120, durationIn: 0.9 }).inUp}
                                sx={{
                                    mb: 1,
                                    // Change border color based on whether it's selected
                                    border: expandedIndex === index ? "2px solid #1E53E8" : "1px solid black",
                                    borderRadius: "4px",
                                    transition: "border-color 0.3s",
                                }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                    <Stack direction="row" spacing={2}>
                                        <img
                                            src={item.iconImage}
                                            alt={item.title}
                                            style={{ width: 40, height: 40 }}
                                        />

                                        <Typography
                                            sx={{ display: "flex", fontSize: "22px !important" }}
                                            className="accSummaryTitle"
                                        >
                                            {item.title}&nbsp;
                                            <span style={{ color: "#1E53E8" }}>
                                                {item.titleHl}
                                            </span>
                                        </Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails
                                    sx={{
                                        // display: "flex",
                                        fontFamily: "Roboto Flex",
                                        justifyContent: "center",
                                        fontSize: '18px',
                                        fontWeight: 400,
                                        paddingLeft: '70px',
                                    }}
                                >
                                    {item.description}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </>}
                    {!mdUp && <>
                        {containerData.map((item, index) => (
                            <Accordion
                                key={index}
                                expanded={expandedIndex === index}
                                onChange={() => handleAccordionChange(index)}
                                sx={{
                                    mb: 1,
                                    // Change border color based on whether it's selected
                                    border: expandedIndex === index ? "2px solid #1E53E8" : "1px solid black",
                                    borderRadius: "4px",
                                    transition: "border-color 0.3s",
                                }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                    <Stack direction="row" spacing={1}>
                                        <img
                                            src={item.iconImage}
                                            alt={item.title}
                                            style={{ width: 35, height: 35 }}
                                        />

                                        <Typography
                                            sx={{ display: "flex",  }}
                                            className="accSummaryTitleMobile"
                                        >
                                            <span> {item.title}&nbsp;</span>
                                            <span style={{ color: "#1E53E8" }}>
                                                {item.titleHl}
                                            </span>
                                        </Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails
                                className="accDetailsMobile"
                                    sx={{
                                        // display: "flex",
                                        fontFamily: "Roboto Flex",
                                        justifyContent: "center",
                                        fontSize: '18px',
                                        fontWeight: 400,
                                    }}
                                >
                                    <Stack direction='column'>
                                        {item.description}
                                        <Image
                                            src={containerData[selectedIndex].mainImg}
                                            alt={containerData[selectedIndex].title}
                                            sx={{
                                                width: "100%",
                                                maxWidth: "100%",
                                                height: "auto",
                                                objectFit: "fill",
                                                mt:2
                                            }}
                                        />
                                    </Stack>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </>}
                </Grid>

                {/* Second Grid: Display selected image */}
                {mdUp && <Grid item xs={12} md={6}
                 component={MotionViewport} 
                 variants={varFade({ distance: 120, durationIn: 0.9 }).inRight}
                 sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                    <Image
                        src={containerData[selectedIndex].mainImg}
                        alt={containerData[selectedIndex].title}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            height: "auto",
                            objectFit: "fill",
                        }}
                    />
                </Grid>}
            </Grid>
        </Container>
    );
}
